module.exports = __webpack_public_path__ + "static/img/plat_04.ca76d65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/internetPlat/plat_04.jpg
// module id = LIKX
// module chunks = 1